export { default } from "@/shell/NotFoundScreen";
